import { render, staticRenderFns } from "./PremiumMembershipSupports.vue?vue&type=template&id=57fdd364&scoped=true"
import script from "./PremiumMembershipSupports.vue?vue&type=script&lang=js"
export * from "./PremiumMembershipSupports.vue?vue&type=script&lang=js"
import style0 from "./PremiumMembershipSupports.vue?vue&type=style&index=0&id=57fdd364&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fdd364",
  null
  
)

export default component.exports